/* eslint-disable no-param-reassign */

import api from '@/services/api/project/project'
export default {
  state: {
    series_name: '',
    filterList: [
      {
        label: '全部',
        value: 0
      },
      {
        label: '结项并优化中',
        value: 10,
        img: 'image/product/icon_user.png',
        class: 'product-status-10',
        classShow: 'product-status-110'
      },
      {
        label: '已结项',
        value: 20,
        img: 'image/product/img_3@2x.png',
        class: 'product-status-20',
        classShow: 'product-status-220'
      },
      {
        label: '研发中',
        value: 30,
        img: 'image/product/img_2@2x.png',
        class: 'product-status-30',
        classShow: 'product-status-330'
      },
      {
        label: '已暂停',
        value: 40,
        img: 'image/product/img_1@2x.png',
        class: 'product-status-40',
        classShow: 'product-status-440'
      }
    ]
  },
  mutations: {
    SET_DATALIST: (state, data) => {
      state.projectList = data
    }
  },
  getters: {},
  actions: {
    getDepartmentProjectfolder({ commit }, params) {
      return new Promise((resolve, reject) => {
        api
          .getDepartmentProjectfolder(params)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}
